import axios from 'axios'
import store from '@/store/index.js'
import helper from '@/utils/helper'
import { v4 as uuidv4 } from 'uuid'
import { message } from '@/utils/message'
import {
  Loading
} from 'element-ui'
var axiosInstance = axios.create({
  timeout: 1200000
})

var loadingInstance = {}
const CODE = {
  SUCCEE: 200,
  SUCCEEELSE: 0,
  NO_LOGIN: 401 // 401 token过期
}

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    if (config.url !== '/logout') {
      if (store.state.token || localStorage.getItem('authorization')) {
        const headers = {
          Authorization: store.state.token || localStorage.getItem('authorization')
        }
        if (config.headers) {
          Object.assign(config.headers, headers)
        } else {
          config.headers = headers
        }
      }
    }
    localStorage.setItem('authorization', config.headers.Authorization)
    loadingInstance = config.closeLoading ? loadingInstance : Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.2)'
    })
    config.closeLoading ? delete config.closeLoading : ''
    const defaultParams = {
      id: uuidv4(),
      timestamp: Date.parse(new Date()),
      version: '1.0'
    }
    // 如果有传递自定义的配置过来
    if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
      // 默认值与接口传来的参数进行合并（注：接口参数与默认值不可重复）
      if (!(config.data instanceof FormData)) { // 如果是模拟form表单提交的请求，则不对其data数据进行处理
        config.data = Object.assign(defaultParams, config.data)
      }
    }
    if (config.method === 'get' && config.data) {
      config.data = Object.assign(defaultParams, config.data)
      config.url = config.url + '?' + helper.serialize(config.data)
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    loadingInstance.close ? loadingInstance.close() : ''
    if (response.config.url !== '/logout') {
      if (response.headers.authorization) {
        console.log('执行token更新机制了')
        console.log('token更新了！', response.headers.authorization)
        store.commit('SET_TOKEN', response.headers.authorization)
      }
    }
    if (response.status === 200) {
      if (response.data.code !== CODE.SUCCEE && response.data.code !== CODE.SUCCEEELSE) {
        // 有统一得信息弹出提示后都Promise.reject一下，防止返回response出现多个弹出提示
        if (response.data.code === CODE.NO_LOGIN) {
          // 未登录的情况
          message({
            message: response.data.message,
            type: 'error'
          })
          return Promise.reject(response.data)
        } else if (response.data.code === 4009 || response.data.code === 4000) {
          message({
            message: response.data.msg || response.data.message,
            type: 'error'
          })
          return Promise.reject(response.data)
        } else if (response.data.code === 1003) {
          message({
            message: response.data.message,
            type: 'error'
          })
          localStorage.clear()
          sessionStorage.clear()
          store.commit('REMOVE_TOKEN', '')
          window.location.hash = '/login'
          return Promise.reject(response.data)
        } else {
          if (response.data.message === 'sn exists!') {
            response.data.message = '数据已存在！'
          }
          message({
            message: response.data.msg || response.data.message,
            type: 'error'
          })
          return Promise.reject(response.data)
        }
      }
      return response
    } else if (response.status === 404) {
      message({
        message: '访问的接口不存在',
        type: 'error'
      })
    }
  },
  // 请求报错时
  function (error) {
    if (!error.response) {
      message({
        message: '网络错误',
        type: 'error'
      })
    }
    if (error.response && error.response.config.url !== '/logout') {
      const originalRequest = error.config
      console.log(originalRequest)
      if (error.response.headers.authorization) {
        console.log('替换新token', error.response.headers.authorization)
        originalRequest.headers.Authorization = error.response.headers.authorization
        store.commit('SET_TOKEN', error.response.headers.authorization)
        loadingInstance.close ? loadingInstance.close() : ''
        return axios.request(originalRequest)
      }
    }
    // console.log('报错请求', error.config)
    if (error.response && error.response.status === 401) {
      if (error.response.data.code === 1003) {
        message({
          message: error.response.data.message,
          type: 'error'
        })
        store.commit('REMOVE_TOKEN', '')
        localStorage.clear()
        sessionStorage.clear()
        window.location.hash = '/login'
      }
      if (error.response.data.code === 4009) {
        message({
          message: error.response.data.message,
          type: 'error'
        })
      }
    } else if (error.response && error.response.status === 400) {
      message({
        message: error.response.data.message,
        type: 'error'
      })
    }
    loadingInstance.close ? loadingInstance.close() : ''
    return Promise.reject(error)
  }
)

export default axiosInstance
